// extracted by mini-css-extract-plugin
export default {"paymentsBlock":"ol9wk","paymentImg":"DjN67"};